import { z } from "zod";

export enum EMyVModeType {
  NORMAL = "NORMAL",
  CONFORT = "CONFORT",
  CONFORTMINUS1 = "CONFORTMINUS1",
  CONFORTMINUS2 = "CONFORTMINUS2",
  ECO = "ECO",
  ECOV = "ECOV",
  HORS_GEL = "HORS_GEL",
  TEMPERATURE = "TEMPERATURE",
  ARRET = "ARRET",
  UNKNOWN = "UNKNOWN",
  ERROR = "ERROR",
}

export const myvModeTypeDto = z.nativeEnum(EMyVModeType);

export type TMyVModeTypeDto = z.infer<typeof myvModeTypeDto>;
